<ng-container *ngIf="operator">
    <img app-imagekit class=""
         *ngIf="operator.logoUrl"
         [source]="operator.logoUrl"
         title="{{operator.name}}"
         [style]="'width: ' + width + 'px; height: ' + height + 'px;'"
         transform="tr:w-{{(width * 2) || 160}},h-{{(height * 2) || 160}},cm-pad_resize,bg-FFFFFF"
         alt="{{operator.name}}"
         >
</ng-container>
